import React from 'react'
import { TextField, VariantType } from '@entur/form'
import { GridContainer, GridItem } from '@entur/grid'
import { getPostalCode } from '../../api-clients/eba-clients'
import { useApi } from '../../api-clients/client-hooks'
import { PostalCode, FetchState } from '../../api-clients/api-types'
import { ValidationFormField, validateFormField } from '../../utils/form-utils'

type PostalFieldProps = {
  postalCode: ValidationFormField<string>
  update: (e: ValidationFormField<string>) => void
}

const PostalField: React.FC<PostalFieldProps> = (props) => {
  const [response, doFetch] = useApi<PostalCode>(getPostalCode)
  const town = response.status === FetchState.SUCCESS && props.postalCode.value !== '' ? response.data.town : ''

  const onBlur = () => {
    doFetch({ query: `${props.postalCode.value}` })
    const validatedFormField = validateFormField(props.postalCode) as ValidationFormField<string>
    props.update(validatedFormField)
  }

  return (
    <GridContainer spacing="extraSmall2">
      <GridItem small={12} medium={4} large={4}>
        <TextField
          name={props.postalCode.fieldName}
          label={props.postalCode.displayName}
          variant={props.postalCode.variant as VariantType}
          feedback={props.postalCode.feedback}
          placeholder="2609"
          value={props.postalCode.value}
          onChange={(e: { target: { value: string } }) =>
            props.update({ ...props.postalCode, value: e.target.value })
          }
          pattern={props.postalCode.validation.pattern}
          onBlur={onBlur}
        />
      </GridItem>
      <GridItem small={12} medium={8}>
        <TextField readOnly label="Poststed" name="town" value={town || ' '} />
      </GridItem>
    </GridContainer>
  )
}

export default PostalField
